import { render, staticRenderFns } from "./MediaOwnersFeatures.vue?vue&type=template&id=659e99fe&"
import script from "./MediaOwnersFeatures.vue?vue&type=script&lang=js&"
export * from "./MediaOwnersFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports